import React from 'react';
import { Row, Col } from 'antd';
import { Title } from '@/components/Typography';
import { NotificationButton } from './NotificationButton';
import { useDataExtractionContext } from '@/context/DataExtraction';
import { CreateDataExtractionButton } from './CreateDataExtractionButton';

export function Header() {
	const { gutterLayout } = useDataExtractionContext();

	return (
		<Row justify="space-between" align="middle">
			<Col span={12}>
				<Title level={3}>Data extraction</Title>
			</Col>
			<Col span={12}>
				<Row justify="end" gutter={gutterLayout}>
					<Col>
						<NotificationButton />
					</Col>
					<Col>
						<CreateDataExtractionButton />
					</Col>
				</Row>
			</Col>
		</Row>
	);
}
